import React, { useState } from "react";
import "./Careers.css";
import careersImg from "../../assets/logo_circle.png";
import { useTranslation } from "react-i18next";

export default function Careers() {
  const { t } = useTranslation();
  const [showTerms, setShowTerms] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    try {
      const res = await fetch("https://security-backend-1nbc.onrender.com/api/apply", {
        method: "POST",
        body: formData,
      });

      if (res.ok) {
        alert(t("careers.alerts.success"));
        e.target.reset();
      } else {
        alert(t("careers.alerts.problem"));
      }
    } catch (err) {
      console.error(err);
      alert(t("careers.alerts.networkError"));
    }
  };

  return (
    <section id="careers" aria-labelledby="careers-heading">
      <div className="careers__inner">
        {/* Left column - copy + form */}
        <div className="careers__copy">
          <p className="eyebrow">{t("careers.eyebrow")}</p>
          <h1 id="careers-heading" className="heading">
            {t("careers.heading")}
          </h1>
          <p className="sub">{t("careers.subheading")}</p>

          <form className="applyForm" onSubmit={handleSubmit}>
            {/* Section 1: Basic Info */}
            <h2 className="formSectionTitle">
              {t("careers.form.personalInfo")}
            </h2>
            <div className="grid">
              <div className="field">
                <label htmlFor="firstName">
                  {t("careers.form.firstName")}
                </label>
                <input id="firstName" name="firstName" type="text" required />
              </div>
              <div className="field">
                <label htmlFor="lastName">
                  {t("careers.form.lastName")}
                </label>
                <input id="lastName" name="lastName" type="text" required />
              </div>
              <div className="field">
                <label htmlFor="email">
                  {t("careers.form.email")}
                </label>
                <input id="email" name="email" type="email" required />
              </div>
              <div className="field">
                <label htmlFor="phone">
                  {t("careers.form.phone")}
                </label>
                <input id="phone" name="phone" type="tel" required />
              </div>
              <div className="field">
                <label htmlFor="address">
                  {t("careers.form.address")}
                </label>
                <input id="address" name="address" type="text" required />
              </div>
              <div className="field">
                <label htmlFor="city">
                  {t("careers.form.city")}
                </label>
                <input id="city" name="city" type="text" required />
              </div>
              <div className="field">
                <label htmlFor="province">
                  {t("careers.form.province")}
                </label>
                <input id="province" name="province" type="text" required />
              </div>
              <div className="field fileField">
                <label htmlFor="license">
                  {t("careers.form.license")}
                </label>
                <input
                  id="license"
                  name="license"
                  type="file"
                  accept=".pdf,.jpeg,.jpg"
                  required
                />
              </div>
              <div className="field">
                <label htmlFor="dob">
                  {t("careers.form.dob")}
                </label>
                <input id="dob" name="dob" type="date" required />
              </div>
              <div className="field fileField">
                <label htmlFor="resume">
                  {t("careers.form.resume")}
                </label>
                <input
                  id="resume"
                  name="resume"
                  type="file"
                  accept=".pdf,.doc,.docx"
                  required
                />
              </div>
              <div className="field fileField">
                <label htmlFor="cert">
                  {t("careers.form.cert")}
                </label>
                <input id="cert" name="cert" type="file" accept=".pdf,.jpeg,.jpg"/>
              </div>
            </div>

            {/* Section 2: Experience */}
            <h2 className="formSectionTitle">
              {t("careers.form.experienceInfo")}
            </h2>
            <div className="grid">
              <div className="field">
                <label>
                  {t("careers.form.experienceLevel")}
                </label>
                <select name="experience" required>
                  <option value="">
                    {t("careers.form.selectOne")}
                  </option>
                  <option value="lt1">
                    {t("careers.form.expLevels.lt1")}
                  </option>
                  <option value="y1">
                    {t("careers.form.expLevels.y1")}
                  </option>
                  <option value="y2">
                    {t("careers.form.expLevels.y2")}
                  </option>
                  <option value="y3">
                    {t("careers.form.expLevels.y3")}
                  </option>
                </select>
              </div>
              <div className="field">
                <label>
                  {t("careers.form.height")}
                </label>
                <input name="height" type="number" />
              </div>
              <div className="field">
                <label>
                  {t("careers.form.weight")}
                </label>
                <input name="weight" type="number" />
              </div>
              <div className="field">
                <label>
                  {t("careers.form.criminalRecord")}
                </label>
                <select name="criminalRecord" required>
                  <option value="">
                    {t("careers.form.selectOne")}
                  </option>
                  <option value="no">
                    {t("careers.form.no")}
                  </option>
                  <option value="yes">
                    {t("careers.form.yes")}
                  </option>
                </select>
              </div>
              <div className="field">
                <label>
                  {t("careers.form.veteran")}
                </label>
                <select name="veteran">
                  <option value="">
                    {t("careers.form.selectOne")}
                  </option>
                  <option value="no">
                    {t("careers.form.no")}
                  </option>
                  <option value="yes">
                    {t("careers.form.yes")}
                  </option>
                </select>
              </div>
              <div className="field">
                <label>
                  {t("careers.form.vehicle")}
                </label>
                <select name="vehicle">
                  <option value="">
                    {t("careers.form.selectOne")}
                  </option>
                  <option value="no">
                    {t("careers.form.no")}
                  </option>
                  <option value="yes">
                    {t("careers.form.yes")}
                  </option>
                </select>
              </div>
              <div className="field">
                <label>
                  {t("careers.form.blackSuit")}
                </label>
                <select name="blackSuit">
                  <option value="">
                    {t("careers.form.selectOne")}
                  </option>
                  <option value="no">
                    {t("careers.form.no")}
                  </option>
                  <option value="yes">
                    {t("careers.form.yes")}
                  </option>
                </select>
              </div>
            </div>

            <div className="field">
              <label htmlFor="notes">
                {t("careers.form.notes")}
              </label>
              <textarea
                id="notes"
                name="notes"
                rows="4"
                placeholder={t("careers.form.notesPlaceholder")}
              ></textarea>
            </div>

            <p className="disclaimer">
              <strong>{t("careers.form.discretion")}</strong>{" "}
              {t("careers.form.disclaimer")}
            </p>

            <label className="check">
              <input type="checkbox" name="consent" required />{" "}
              {t("careers.form.consent")}
            </label>

            <div className="termsLink">
              <button
                type="button"
                className="linkBtn"
                onClick={() => setShowTerms(true)}
              >
                {t("careers.form.viewTerms")}
              </button>
            </div>

            <div className="actions">
              <button type="submit" className="btnPrimary">
                {t("careers.form.submit")}
              </button>
            </div>
          </form>
        </div>

        {/* Right column - image */}
        <div className="careers__image" aria-hidden="true">
          <img
            src={careersImg}
            alt={t("careers.imageAlt")}
            loading="lazy"
          />
        </div>
      </div>

      {/* Terms of Service Popup */}
      {showTerms && (
        <div className="termsModal">
          <div className="termsModal__content">
            <h2>{t("careers.terms.title")}</h2>
            <div className="termsModal__scroll">
              {t("careers.terms.sections", { returnObjects: true }).map(
                (section, index) => (
                  <p key={index}>
                    <strong>{section.title}</strong>
                    <br />
                    {section.content}
                  </p>
                )
              )}
            </div>
            <div className="termsModal__actions">
              <button
                className="btnPrimary"
                onClick={() => setShowTerms(false)}
              >
                {t("careers.terms.understand")}
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
